import { DataLinkPage } from '../../DataLink';
import { DataPreviewArticleImage as DPAImage } from '../../DataAssets';

const DataArticle = {
  path: DataLinkPage.edu_mengenalLebihDalamWholeLifeInsurance,
  preview: {
    title: [
      {
        text: 'Mengenal Lebih Dalam ',
      },
      {
        text: 'Whole Life Insurance',
        type: 'italic',
      },
    ],
    subInfo: {
      author: 'Rivo Bifa',
      linkProfile: DataLinkPage.author_rivoBifa,
      timestamp: 'Selasa, 25 Januari 2022',
      location: 'Jakarta',
    },
    content: [
      {
        paragraph: [
          [
            {
              text: 'Artikel ini akan membahas bagaimana produk ',
            },
            {
              text: 'Whole Life Insurance',
              type: 'ins-term',
            },
            {
              text: ' digunakan serta hubungannya dengan tabel mortalita yang menyebabkan ',
            },
            {
              text: 'Manfaat Asuransi',
              type: 'ins-term',
            },
            {
              text: ' dari produk ',
            },

            {
              text: 'Whole Life Insurance',
              type: 'ins-term',
            },
            {
              text: ' tidak selalu diberikan sebagai santunan kepada ahli waris yang ditinggalkan.',
            },
          ],
        ],
        previewArticle: DPAImage.mengenalLebihDalamWholeLifeInsurance,
      },
    ],
  },
  section: [
    {
      content: [
        {
          paragraph: [
            [
              {
                text: 'Sebelumnya',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' udah buat artikel tentang penjelasan jenis produk asuransi jiwa, di sana ada definisi dari ',
              },
              {
                text: 'Whole Life Insurance',
                type: 'ins-term',
              },
              {
                text: '. Kalau ',
              },
              {
                text: 'lo',
                type: 'italic',
              },
              {
                text: ' mau ',
              },
              {
                text: 'lo',
                type: 'italic',
              },
              {
                text: ' bisa baca di ',
              },
              {
                text: 'Jenis Produk Asuransi Jiwa',
                type: 'link-page',
                path: DataLinkPage.edu_jenisProdukAsuransiJiwa,
              },
            ],
            [
              {
                text: 'In case',
                type: 'italic',
              },
              {
                text: ' temen-temen lupa apa itu ',
              },
              {
                text: 'Whole Life Insurance',
                type: 'ins-term',
              },
              {
                text: ', ',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' coba kasih penjelasan sesingkat mungkin ya.',
              },
            ],
            [
              {
                text: 'Whole Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' merupakan produk asuransi jiwa dengan ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' yang akan diterima jika Peserta meninggal (tanpa batas periode).',
              },
            ],
            [
              {
                text: 'Nah dari penjelasan tersebut, kita bisa menyimpulkan bahwa ',
              },
              {
                text: 'Whole Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' juga merupakan ',
              },
              {
                text: 'Term Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' yang periode pertanggungannya ditarik sampai waktu dimana Peserta meninggal.',
              },
            ],
            [
              {
                text: 'Boleh dong?? Ya boleh lah.',
              },
            ],
            [
              {
                text: 'Karena ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' diberikan kapan aja ketika kematian terjadi, berarti proteksi risiko bakalan terus berlanjut sampai Peserta tersebut meninggal. Kalau lo bingung coba deh baca dulu tulisan ',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' soal ',
              },
              {
                text: 'Jenis Produk Asuransi Jiwa',
                type: 'link-page',
                path: DataLinkPage.edu_jenisProdukAsuransiJiwa,
              },
              {
                text: '. Kalau udah balik lagi sini ya.',
              },
            ],
            [
              {
                text: 'Oke lanjut...',
              },
            ],
            [
              {
                text: 'Ternyata dalam praktiknya konsep tersebut ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' sepenuhnya benar, tapi juga ',
              },
              {
                text: 'nggak',
                type: 'italic',
              },
              {
                text: ' sepenuhnya salah. Coba deh inget lagi, salah satu faktor utama dalam membentuk asumsi pada asuransi jiwa apa? ',
              },
              {
                text: 'Yups',
                type: 'italic',
              },
              {
                text: ', tabel mortalita. Sadar kan kalau tabel tersebut (yang standar dari institusi) ada batas usianya. Batas tabel mortalita di Indonesia menunjuk pada usia 111. Hal ini mengartikan bahwa pada umumnya masyarakat Indonesia meninggal sebelum mencapai usia 111.',
              },
            ],
            [
              {
                text: 'Gue nggak',
                type: 'italic',
              },
              {
                text: ' bermaksud ngomongin takdir kematian, tapi ya ini artinya kalau ',
              },
              {
                text: 'lo',
                type: 'italic',
              },
              {
                text: ' adalah salah satu dari sekian populasi di Indonesia yang beruntung mencapai usia lebih dari batas tabel mortalita tersebut, ',
              },
              {
                text: 'lo',
                type: 'italic',
              },
              {
                text: ' bisa memperoleh ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' dari produk ',
              },
              {
                text: 'Whole Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' tanpa harus meninggal!',
              },
            ],
            [
              {
                text: 'Wow... ',
              },
              {
                text: 'Amazing',
                type: 'italic',
              },
              {
                text: ' bukan? Ya memang sedikit kontra dengan teori di atas, tapi memang ini lah realitanya.',
              },
            ],
            [
              {
                text: 'Kenapa ',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' bilang begitu? karena kalau ',
              },
              {
                text: 'lo',
                type: 'italic',
              },
              {
                text: ' udah cobain ',
              },
              {
                text: 'Kalkulator Asuransi',
                type: 'link-page',
                path: DataLinkPage.calc_home,
              },
              {
                text: ', ',
              },
              {
                text: 'lo',
                type: 'italic',
              },
              {
                text: ' bakal nemuin kalau produk asuransi jiwa yang seperti itu, ',
              },
              {
                text: 'Endowment Insurance',
                type: 'ins-term',
              },
              {
                text: ', yang dapat diperoleh manfaatnya baik Peserta meninggal atau masa pertanggungan habis, itu jauh lebih mahal dari pada produk ',
              },
              {
                text: 'Whole Life Insurance',
                type: 'ins-term',
              },
              {
                text: '. Apalagi kalau produk ',
              },
              {
                text: 'Endowment Insurance',
                type: 'ins-term',
              },
              {
                text: '-nya dengan periode pertanggungan yang pendek. Meskipun begitu, produk ',
              },
              {
                text: 'Endowment Insurance',
                type: 'ins-term',
              },
              {
                text: ' tetap akan bernilai sama dengan produk ',
              },
              {
                text: 'Whole Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' kalau periode pertanggungannya hingga batas mortalita. Hal ini ',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: 'coba jelasin di artikel selanjutnya yaitu ',
              },
              {
                text: 'Endowment Insurance vs Whole Life Insurance',
                type: 'link-page',
                path: DataLinkPage.edu_endowmentInsuranceVsWholeLifeInsurance,
              },
              {
                text: '.',
              },
            ],
            [
              {
                text: 'For your information',
                type: 'italic',
              },
              {
                text: ', beberapa Perusahaan Asuransi Jiwa menjual produk serupa dengan batas tabel mortalita hanya sampai dengan 100 tahun saja. lebih cepat 11 tahun dari tabel biasanya.',
              },
            ],
          ],
        },
      ],
    },
  ],
  conclusion: {
    title: [
      {
        text: 'Kesimpulan',
      },
    ],
    content: [
      {
        paragraph: [
          [
            {
              text: 'Produk ',
            },
            {
              text: 'Whole Life Insurance',
              type: 'ins-term',
            },
            {
              text: ' adalah produk dengan ',
            },
            {
              text: 'Manfaat Asuransi',
              type: 'ins-term',
            },
            {
              text: ' yang akan diterima jika terjadi kematian (tanpa batas periode). Intepretasi ',
            },
            {
              text: 'Klaim',
              type: 'ins-term',
            },
            {
              text: ' dari produk ini tidak selalu harus terjadi kematian. Namun juga bisa saat Peserta telah melewati batas mortalita.',
            },
          ],
        ],
      },
    ],
  },
};

export default DataArticle;
